import { InjectionToken } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface ModalModel<TData = unknown> {
  className?: string;
  data?: Partial<TData>;
  size?: string;
  backdrop?: boolean | 'static';
  ignoreBackdropClick?: boolean;
  keyboard?: boolean;
  animated?: boolean;
}

export interface IModalService {
  displayModal<TData>(
    component: any,
    data?: Partial<TData>,
    size?: string, allowEscape?: boolean | 'static',
    backdrop?: boolean | 'static', centered?: boolean): BsModalRef<TData>;
  displayCustomModal<TData>(component: any, options?: ModalModel<TData>): BsModalRef<TData>;
}

export const MODAL_SERVICE_TOKEN = new InjectionToken<IModalService>('IModalService');
